var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "prime-box" }, [
      _c("div", { staticClass: "icon-container" }, [
        _c("img", {
          attrs: { src: "/static-appopensalud/img/home/ohealth-logo.png" }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "services-p" }, [
          _vm._v("Otros servicios de "),
          _c("br"),
          _vm._v("salud bonificados")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "services-p2" }, [
          _vm._v("\n            Consultas, pruebas diagnósticas"),
          _c("br"),
          _vm._v("\n            y tratamientos a precio reducido.\n        ")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b114648", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b114648","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/patient/GoOpensaludpass.vue
// module id = 2104
// module chunks = 116